// extracted by mini-css-extract-plugin
export default {"detailsTable":"TravelDetailTable_detailsTable__CHFza","detailsButton":"TravelDetailTable_detailsButton__bFqSc","eventDate":"TravelDetailTable_eventDate__Ovo1O"};